import blog1 from '../img/portImages/laptop1.jpg';
import blog2 from '../img/portImages/graduate.jpg';

const blogs = [
  {
    id: 1,
    image: blog1,
    title: 'Picking the right coding language in 2021',
    link: 'https://chriskang24.medium.com/picking-the-right-coding-language-in-2021-417b370e4216',
  },
  {
    id: 2,
    image: blog2,
    title: 'Lighthouse Labs Graduation',
    link: 'https://www.linkedin.com/posts/chrisjkang_i-am-excited-to-announce-that-i-have-received-activity-6783067788878630912-DeMV',
  },
 
];

export default blogs;